const ssn = {
    ssn : {
        value : "",
        dbqNames: "form1[0].#subform[0].SSN[0]",
    },
    examDate: {
        value: "",
        dbqName: "form1[0].#subform[0].DateOfExam[0]"
    },
     docName: {
         value: "",
         dbqName: "form1[0].#subform[15].SectionXVII-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value : "",
        dbqName: "form1[0].#subform[15].SectionXVII-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "form1[0].#subform[15].SectionXVII-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "form1[0].#subform[15].SectionXVII-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "form1[0].#subform[15].SectionXVII-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "form1[0].#subform[15].SectionXVII-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "form1[0].#subform[15].SectionXVII-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_spondylitis[0]",
            dateDbqName: "form1[0].#subform[4].Date1[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_strain[0]",
            dateDbqName: "form1[0].#subform[4].Date2[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_arthritis[0]",
            dateDbqName: "form1[0].#subform[4].Date6[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_disc[0]",
            dateDbqName: "form1[0].#subform[4].Date7[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_syndrome[0]",
            dateDbqName: "form1[0].#subform[4].Date3[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_instability[0]",
            dateDbqName: "form1[0].#subform[4].Date8[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_fusion[0]",
            dateDbqName: "form1[0].#subform[4].Date9[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_stenosis[0]",
            dateDbqName: "form1[0].#subform[4].Date10[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_Spondylolisthesis[0]",
            dateDbqName: "form1[0].#subform[4].Date11[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_dislocation[0]",
            dateDbqName: "form1[0].#subform[4].Date12[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_fracture[0]",
            dateDbqName: "form1[0].#subform[4].Date13[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnosis_paralysis[0]",
            dateDbqName: "form1[0].#subform[4].Date14[0]",
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[4].OtherDiagnosis1[0]",
            dateDbqName: "form1[0].#subform[4].DateOfDiagnosis15[0]",
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[4].OtherDiagnosis2[0]",
            dateDbqName: "form1[0].#subform[4].DateOfDiagnosis16[0]",
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[4].OtherDiagnosis3[0]",
            dateDbqName: "form1[0].#subform[4].DateOfDiagnosis17[0]",
        },        
    ]
}

export default ssn ;